/* NURIALE — Heirloom Silk Film (June 2026).
   Companion to sections/nur-silk-film.liquid.
   - Lazy: video src is only assigned when the section is within ~2
     viewports (HD on desktop, SD on small screens / save-data).
   - Polite: plays only while ≥25% visible and the tab is foregrounded.
   - Accessible: reduced-motion and save-data users keep the poster and get
     a tap-to-play button with native controls instead of autoplay. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var films = Array.prototype.slice.call(document.querySelectorAll('[data-nur-film]'));
    if (!films.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = !!(navigator.connection && navigator.connection.saveData);

    films.forEach(function (film) {
      var video = film.querySelector('.nur-film__video');
      var playBtn = film.querySelector('.nur-film__play');
      if (!video) return;

      function chooseSrc() {
        var hd = video.getAttribute('data-src-hd');
        var sd = video.getAttribute('data-src-sd');
        return (window.innerWidth >= 768 && !saveData && hd) ? hd : (sd || hd);
      }

      if (reduce || saveData || !('IntersectionObserver' in window)) {
        // No autoplay: poster + explicit play with native controls.
        film.classList.add('nur-film--in');
        if (playBtn) {
          playBtn.hidden = false;
          playBtn.addEventListener('click', function () {
            video.src = video.getAttribute('data-src-sd') || video.getAttribute('data-src-hd');
            video.controls = true;
            playBtn.hidden = true;
            video.play().catch(function () {});
          });
        }
        return;
      }

      // Assign src once the section is within ~2 viewports.
      var loadIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!video.getAttribute('src')) {
            video.src = chooseSrc();
            video.load();
          }
          loadIO.disconnect();
        });
      }, { rootMargin: '200% 0px' });
      loadIO.observe(film);

      // Play only while visible; reveal choreography on first entry.
      var inView = false;
      var playIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            film.classList.add('nur-film--in');
            if (video.getAttribute('src')) {
              video.muted = true;
              video.play().catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      playIO.observe(film);

      // Never burn battery in a background tab.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          video.pause();
        } else if (inView && video.getAttribute('src')) {
          video.play().catch(function () {});
        }
      });

      // If the data arrives while we're already in view, start.
      video.addEventListener('loadeddata', function () {
        if (inView) video.play().catch(function () {});
      });
    });
  });
})();
